import {BrowserRouter, Route, Switch, useLocation} from "react-router-dom";
import {Container} from "@mui/material";
import { ThemeProvider, createTheme } from '@mui/material/styles';

import {AppRoutesPublic} from "./App.Routes.Public";
import {AppRoutesUser} from "./App.Routes.User";
import {AppRoutesSponsor} from "./App.Routes.Sponsor";
import {AppRoutesAdmin} from "./App.Routes.Admin";
import {Header as HeaderSponsor} from "./Components/Sponsor/Header";
import {Header as HeaderAdmin} from "./Components/Admin/Header";
import {Header as HeaderPublic} from "./Components/Public/Header";
import {Header as HeaderUser} from "./Components/User/Header";
import {blue, lightBlue, deepOrange, orange, green, teal} from "@mui/material/colors";
import {store} from 'state-pool';
import {LOCALSTORAGE_TOKEN_USER, LOCALSTORAGE_TOKEN_SPONSOR, LOCALSTORAGE_TOKEN_ADMIN} from "./Constants";
import {IndexPage} from "./Pages/Public/IndexPage";
import { HelmetProvider } from 'react-helmet-async';
import { LandingPage } from "./Pages/Redesign/LandingPage";
import { PartnersPage } from "./Pages/Redesign/PartnersPage";
import { TopScreen } from "./Pages/Redesign/TopScreen";
import { MapScreen } from "./Pages/Redesign/MapScreen";
import { WalletScreen } from "./Pages/Redesign/WalletScreen";
import { MeScreen } from "./Pages/Redesign/MeScreen";
import { EditProfileScreen } from "./Pages/Redesign/EditProfileScreen";
import { DetailScreen } from "./Pages/Redesign/DetailScreen";
import { HubScreen } from "./Pages/Redesign/HubScreen";
import { ActiveScreen } from "./Pages/Redesign/ActiveScreen";
import { LoginLandingPage } from "./Pages/Redesign/LoginLandingPage";

const theme = createTheme({
  palette: {
    primary: blue,
    secondary: lightBlue,
  },
});

const themeSponsor = createTheme({
  palette: {
    primary: teal,
    secondary: green,
  },
});

const themeAdmin = createTheme({
  palette: {
    primary: deepOrange,
    secondary: orange,
  },
});

const SponsorRoute: React.FC = () => {
  const location = useLocation();
  const isIndex = location.pathname === "/sponsor";
  const loggedIn = !!localStorage.getItem(LOCALSTORAGE_TOKEN_SPONSOR);

  if (isIndex && !loggedIn) {
    return <PartnersPage />;
  }

  return (
    <div className="flex flex-col h-screen">
      <HeaderSponsor />
      <div className="flex-1">
        <AppRoutesSponsor />
      </div>
    </div>
  );
};

const App: React.FC = () => {

  let loggedInSponsor = false;
  let loggedInAdmin = false;
  let loggedInUser = false;

  if (localStorage.getItem(LOCALSTORAGE_TOKEN_USER)) {
    loggedInUser = true
  }
  if (localStorage.getItem(LOCALSTORAGE_TOKEN_SPONSOR)) {
    loggedInSponsor = true
  }
  if (localStorage.getItem(LOCALSTORAGE_TOKEN_ADMIN)) {
    loggedInAdmin = true
  }

  store.setState("loggedInUser", loggedInUser);
  store.setState("loggedInSponsor", loggedInSponsor);
  store.setState("loggedInAdmin", loggedInAdmin);

  const helmetContext = {};

  return (
    <BrowserRouter>
      <HelmetProvider context={helmetContext}>
      <Container component="main" style={{maxWidth: "100%", margin: "0px", padding: "0px"}}>
        <ThemeProvider theme={theme}>
          {/* Full-bleed redesigned marketing pages */}
          <Route exact={true} path="/">
            <LandingPage/>
          </Route>
          <Route exact={true} path="/partners">
            <PartnersPage />
          </Route>

          {/* Mobile-first redesigned PWA screens */}
          <div className="sm:border-l sm:border-r" style={{ margin: "0 auto", maxWidth: "640px" }}>
            <Switch>
              <Route exact={true} path="/discover" component={TopScreen}/>
              <Route exact={true} path="/discover/:cat" component={TopScreen}/>
              <Route exact={true} path="/area/:name" component={TopScreen}/>
              <Route exact={true} path="/area/:name/:cat" component={TopScreen}/>
              <Route exact={true} path="/map" component={MapScreen}/>
              <Route exact={true} path="/wallet" component={WalletScreen}/>
              <Route exact={true} path="/me" component={MeScreen}/>
              <Route exact={true} path="/me/edit" component={EditProfileScreen}/>
              <Route exact={true} path="/c/:id" component={DetailScreen}/>
              <Route exact={true} path="/h/:id" component={HubScreen}/>
              <Route exact={true} path="/active" component={ActiveScreen}/>
              <Route exact={true} path="/active/:id" component={ActiveScreen}/>
              <Route exact={true} path="/public/oauth/instabase" component={LoginLandingPage}/>
              <Route path="/public">
                <HeaderPublic/>
                <div>
                  <AppRoutesPublic/>
                </div>
              </Route>
              {/* Legacy index page kept reachable for back-compat */}
              <Route exact={true} path="/legacy">
                <HeaderPublic/>
                <IndexPage/>
              </Route>
            </Switch>
          </div>

          <Route path="/users">
            <HeaderUser/>
            <div>
              <AppRoutesUser/>
            </div>
          </Route>
        </ThemeProvider>

        <ThemeProvider theme={themeSponsor}>
          <Route path="/sponsor">
            <SponsorRoute />
          </Route>
        </ThemeProvider>

        <ThemeProvider theme={themeAdmin}>
          <Route path="/admin">
            <HeaderAdmin/>
            <div>
              <AppRoutesAdmin/>
            </div>
          </Route>
        </ThemeProvider>

      </Container>
      </HelmetProvider>
    </BrowserRouter>
  );
};

export default App;
